import { createSelector } from 'reselect';

import { EProductsId } from '@r1-frontend/shared/types/EProductsId';

import { TInitialState } from '~/src/components/ConnectDomruPopup/context/initialState';

export const getSelectedProductsIds = createSelector(
    [
        (state: TInitialState) => state.productFilters,
    ],
    (filters) => {
        const productIdsArray = new Set<EProductsId>([EProductsId.internet]);

        filters
            .filter(filter => filter.checked)
            .forEach(({ id }) => {
                if (typeof id === 'undefined') {
                    productIdsArray.add(EProductsId.tv);
                } else {
                    productIdsArray.add(id);
                }
            });

        return [...productIdsArray];
    },
);
